module.exports = __webpack_public_path__ + "static/img/18.e2b9832.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/18.png
// module id = 1KPs
// module chunks = 0